// extracted by mini-css-extract-plugin
module.exports = {"pointer":"_base-link-dff759071431d2b46dad4f5f5c40a8a4","th":"_base-link-a6623e6c6608a1693c043058d1fc118a"};